import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ChartTooltip } from '@/components/ui/chart';
import {
  deriveOccupancyStats,
  MEDIAN_LINE_KEY,
} from '@/routes/(app)/(scenarios)/utils/scenario.utils';

const ScenarioOccupancyChartTooltip: FC<
  React.ComponentProps<typeof ChartTooltip>
> = ({ active, payload }) => {
  const { t } = useTranslation();
  const [first] = payload ?? [];

  const stats = useMemo(() => {
    // remove the median line from the payload
    const filteredPayload = (payload ?? []).filter(
      (item) => !String(item.dataKey).endsWith(MEDIAN_LINE_KEY)
    );
    return deriveOccupancyStats(filteredPayload);
  }, [payload]);

  if (!active || !stats) return null;

  const { min, median, max } = stats;

  return (
    <div className='border-border/50 bg-background grid min-w-[8rem] items-start gap-1.5 rounded-lg border px-2.5 py-1.5 text-xs shadow-xl'>
      <p className='font-medium'>{first?.payload?.date}</p>
      <div className='grid gap-1'>
        <p>
          {t('simulations.table.min', {
            name: min.name,
            value: Math.ceil(min.value),
          })}
        </p>
        {median && (
          <p>
            {t('simulations.table.median', {
              name: median.name,
              value: Math.ceil(median.value),
            })}
          </p>
        )}
        {max && (
          <p>
            {t('simulations.table.max', {
              name: max.name,
              value: Math.ceil(max.value),
            })}
          </p>
        )}
      </div>
    </div>
  );
};

export default ScenarioOccupancyChartTooltip;
